import { Link } from "gatsby"
import React from "react"
import SocialIcons from "../Features/socialIcons"
export default function Footer() {
  return (
    <div className="bg-white">
      <hr className="m-0" />
      <div className="bg-white container p-4 h-100">
        <div className="row">
          <div className="col-md-4 h-100 align-self-center">
            <h4>
              About <Link>Freelancology</Link>
            </h4>
            <p className="text-justify">
              The Freelancology is a blog website that covers all sorts of News
              / Shobiz / Sports / Mobile / Packages / new Techniques and
              Technologies articles.
            </p>
          </div>
          <div className="col-md-4 pb-3">
            <SocialIcons />
          </div>
          <div className="col-md-4 text-center">
            <iframe
              title="Freelancology Facebook Page"
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffreelancology%2F&tabs=timeline&width=300px&height=130px&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
              width="100%"
              height="130px"
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameborder="0"
              allowTransparency="true"
              allow="encrypted-media"
            ></iframe>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-sm-12 text-center">
            <hr />
            <ul className="list-inline">
              {" | "}
              <li className="list-inline-item">
                <Link to="/">Home</Link>
              </li>
              {" | "}
              {/* <li className="list-inline-item">
                <Link to="/posts/">Posts</Link>
              </li>
              {" |"}
              {"  "} */}
              <li className="list-inline-item">
                <Link to="/about/">About us</Link>
              </li>
              {" | "}
              <li className="list-inline-item">
                <Link to="/contact/">Contact</Link>
              </li>
              {" | "}
              <li className="list-inline-item">
                <Link to="/privacy-policy/">Privacy Policy</Link>
              </li>
              {" | "}
              <li className="list-inline-item">
                <Link to="/disclaimer/">Disclaimer</Link>
              </li>
            </ul>
          </div>
          <div className="col-md-6 col-sm-12">
            <hr />
            <p className="text-center ">
              {" "}
              Freelancology © {new Date().getFullYear()}, Project of{" "}
              <a href="https://extrapixels.netlify.app/">ExtraPixels</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
